export class ChartData {
  name: string = "";
  data: number[] = [];
  type: "bar" | "line" = "bar";
  stack: string = "x";
}

export class BarChartData extends ChartData {
  constructor() {
    super();
    this.type = "bar";
  }
}

export class LineChartData extends ChartData {
  showArea: boolean = true;
  smooth: boolean = true;

  constructor() {
    super();
    this.type = "line";
  }
}

export class ChartInfo {
  title: string = "";
  subtitle: string = "";
  labels: string[] = [];
  height: string = "h-[400px]";
  currency: boolean = false;
  minInterval: number = 0;
  xaxisRotate: number = 0;
  showLegend: boolean = true;
}

export class BarChartInfo extends ChartInfo {
  bars: BarChartData[] = [];
}

export class LineChartInfo extends ChartInfo {
  lines: LineChartData[] = [];
}

export class PieChartInfo {
  title: string = "";
  subtitle: string = "";
  titleTopPosition: string = "top";
  titelLeftPosition: string = "center";
  data: number[] = [];
  labels: string[] = [];
  height: string = "h-[400px]";
  donut: boolean = false;
  currency: boolean = false;
}
